<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Finalizar FAA em massa"
    >
        <rkm-form
            v-if="model"
            ref="Form"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        :end-validations="validations.periodo.end"
                        :max-date="additionals.dataAtual"
                        :range-inline="false"
                        :start-validations="validations.periodo.start"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :disabled="!model.periodo.start || !model.periodo.end"
                        :options="form.unidades"
                        :validations="validations.unidadeId"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :disabled="!model.unidadeId"
                        :options="form.infraestruturas"
                        :validations="validations.infraestruturaId"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :disabled="!model.infraestruturaId"
                        :options="form.centrosCusto"
                        :validations="validations.centroCustoId"
                        label="Setor"
                        show-default-option
                        text-field="nome"
                        v-model="model.centroCustoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                unidadeId: { required: true },
                infraestruturaId: { required: true },
                centroCustoId: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            fechamentoFaaMassa: this.getConectaSusRepository('prontoAtendimento.fechamentoFaaMassa'),
        }
    },
    data: () => ({
        additionals: null,
        form: null,
        model: null,
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.load()
            this.$refs.Modal.show()
        },
        load() {
            this.setLoading()

            this.repositories.fechamentoFaaMassa.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.centrosCusto = []
            this.model.infraestruturaId = null
            this.model.centroCustoId = null

            if (value) {
                const startDate = this.others.moment(this.model.periodo.start).format('YYYY-MM-DD')
                const endDate = this.others.moment(this.model.periodo.end).format('YYYY-MM-DD')

                this.getInfraestruturas(startDate, endDate, value)
            }
        },
        handleInfraestruturaChange(value) {
            this.form.centrosCusto = []
            this.model.centroCustoId = null

            if (value) {
                const startDate = this.others.moment(this.model.periodo.start).format('YYYY-MM-DD')
                const endDate = this.others.moment(this.model.periodo.end).format('YYYY-MM-DD')

                this.getCentrosCusto(startDate, endDate, value)
            }
        },
        handleSave() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        let request = {
                            startDate: this.others.moment(this.model.periodo.start).format('YYYY-MM-DD'),
                            endDate: this.others.moment(this.model.periodo.end).format('YYYY-MM-DD'),
                            centroCustoId: this.model.centroCustoId,
                        }

                        this.repositories.fechamentoFaaMassa.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$refs.Modal.hide()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        resetForm() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.centrosCusto = []
            
            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.centroCustoId = null
        },
        getUnidades(startDate, endDate) {
            this.setLoading()

            const request = {
                listar: 'unidades',
                startDate,
                endDate,
            }

            this.repositories.fechamentoFaaMassa.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.unidades = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas(startDate, endDate, unidadeId) {
            this.setLoading()

            const request = {
                listar: 'infraestruturas',
                startDate,
                endDate,
                unidadeId,
            }

            this.repositories.fechamentoFaaMassa.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCentrosCusto(startDate, endDate, infraestruturaId) {
            this.setLoading()

            const request = {
                listar: 'centros-custo',
                startDate,
                endDate,
                infraestruturaId,
            }

            this.repositories.fechamentoFaaMassa.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.centrosCusto = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository, stringCase ],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.centrosCusto = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.centroCustoId = null

                if (value.start && value.end) {
                    const startDate = this.others.moment(value.start).format('YYYY-MM-DD')
                    const endDate = this.others.moment(value.end).format('YYYY-MM-DD')

                    this.getUnidades(startDate, endDate)
                }
            },
        },
    },
}
</script>